import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'primereact/button'
import { Page } from '../../../components/page/Page'
import utils from '../../../utils/index'
import { actions } from '../reconciliacaoPixAutomatico.actions'
import { ReconciliacaoPixAutomaticoList } from './ReconciliacaoPixAutomaticoList'

const mapStateToProps = (state) => {
  return {
    records: state.crudReconciliacaoPixAutomaticoState.records,
    isLoadingRecords: state.crudReconciliacaoPixAutomaticoState.isLoadingRecords,
    selectedRecords: state.crudReconciliacaoPixAutomaticoState.selectedRecords,
    resultado: state.crudReconciliacaoPixAutomaticoState.resultado,
    messages: state.crudReconciliacaoPixAutomaticoState.messages,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    carregarCandidatos: () => dispatch(actions.carregarCandidatos()),
    setSelectedRecords: (records) => dispatch(actions.setSelectedRecords(records)),
    reconciliar: (oidsItens) => dispatch(actions.reconciliar(oidsItens)),
  }
}

class ReconciliacaoPixAutomaticoListPageContainer extends React.Component {
  componentDidMount() {
    this.props.carregarCandidatos()
  }

  onSelectionChange = (e) => {
    this.props.setSelectedRecords(e.value)
  }

  verificarHabilitadoReconciliar = () => {
    return !(utils.nonNull(this.props.selectedRecords) && utils.isArrayNotEmpty(this.props.selectedRecords))
  }

  reconciliarSelecionados = () => {
    const oidsItens = this.props.selectedRecords.map((item) => item.oidItem)
    this.props.reconciliar(oidsItens)
  }

  buildHeader = () => {
    return (
      <div className="p-toolbar p-component">
        <div className="p-toolbar-group-left">
          <h3>
            {utils.getMessage(this.props.messages, 'reconciliacaopixautomatico.label.reconciliacaopixautomatico')}
          </h3>
        </div>
        <div className="p-toolbar-group-right">
          <Button
            icon="pi pi-refresh"
            onClick={this.props.carregarCandidatos}
            label={utils.getMessage(this.props.messages, 'reconciliacaopixautomatico.label.recarregar')}
            className="p-button-secondary"
            style={{ marginRight: '.5em' }}
          />
          <Button
            disabled={this.verificarHabilitadoReconciliar()}
            onClick={this.reconciliarSelecionados}
            label={utils.getMessage(this.props.messages, 'reconciliacaopixautomatico.label.reconciliarselecionados')}
            className="p-button-success"
          />
        </div>
      </div>
    )
  }

  buildContent = () => {
    return (
      <ReconciliacaoPixAutomaticoList
        records={this.props.records}
        selectedRecords={this.props.selectedRecords}
        onSelectionChange={this.onSelectionChange}
        resultado={this.props.resultado}
        messages={this.props.messages}
      />
    )
  }

  render() {
    // Estas telas nao tem o guard de colunas nem o LoadingSpinner de primeira carga; o
    // `loading` do Page e o unico retorno visual da espera ao paginar, ordenar ou filtrar.
    return <Page header={this.buildHeader()} content={this.buildContent()} loading={this.props.isLoadingRecords} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReconciliacaoPixAutomaticoListPageContainer)
